module.exports = __webpack_public_path__ + "static/media/rulesConsole.12e0c182.png";